import { ELanguage } from '@microfrontends/app-shell-v2'
import React, { ReactNode, useContext, useReducer } from 'react'
import { createTFunction } from '../helpers/common'
import { ICompanyListResponse } from '../services/companyListService'
import { TAuthUser } from '../services/userService'
import reducer from './reducer'

type TStoreProps = {
    children: ReactNode
    langCode: ELanguage
}

export type AppStoreState = {
    langCode: ELanguage
    user: TAuthUser | null
    companyList: ICompanyListResponse[]
    companyIndustries: any[]
    t: (key: string) => string
    isMobile: boolean
    isRobot: boolean
    companyJobs?: any
}

export const initAppStoreState: AppStoreState = {
    langCode: ELanguage.VI,
    user: null,
    companyList: [],
    companyIndustries: [{ id: -1, nameEn: 'All industries', name: 'Tất cả lĩnh vực' }],
    t: createTFunction(ELanguage.VI),
    isMobile: false,
    isRobot: false
}

export type TDispatchAction = {
    type: string
    payload: any
}

const StoreContext = React.createContext<{
    state: AppStoreState
    dispatch: React.Dispatch<TDispatchAction>
}>({
    state: initAppStoreState,
    dispatch: () => null
})

const AppStoreProvider = ({ children, langCode = ELanguage.VI, isRobot = false, companyJobs }: TStoreProps & Partial<AppStoreState>) => {
    const [state, dispatch] = useReducer(reducer, {
        ...initAppStoreState,
        langCode,
        isRobot,
        companyJobs
    })

    const t = createTFunction(state.langCode)

    return (
        <StoreContext.Provider value={{ state: { ...state, t }, dispatch }}>
            {children}
        </StoreContext.Provider>
    )
}

const useStore = () => {
    return useContext(StoreContext)
}

export { AppStoreProvider, useStore }
